import React from 'react';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export type FeedType = {
	name: string;
	sec: string;
	path: string;
	imgPath: string;
};

export const SelectionCardItem = ({ name, sec, path, imgPath }: FeedType) => {
	const ref: any = useRef<null>(null);

	const navigate = useNavigate();

	return (
		<div
			className="feed-card-zoom cursor-pointer"
			onClick={() => {
				navigate(path);
			}}
			ref={ref}
		>
			<div
				className="feed-card-zoom-image"
				style={{
					backgroundImage: `url("${imgPath}")`
				}}
			></div>
			<h1
				// Gets the width of the parent and determines the font size from it
				style={{
					fontSize: ref.current ? ref.current.offsetWidth / 10 : '3em'
				}}
				className={'feed-card-zoom-text-default opacity-90'}
			>
				{name}
			</h1>

			<div className="absolute inset-0 bg-gradient-to-t from-black/75 opacity-0 hover:opacity-100 transition-all duration-500 text-center">
				<h1
					style={{
						fontSize: ref.current ? ref.current.offsetWidth / 13 : '3em'
					}}
					className="feed-card-zoom-text "
				>
					{sec}
				</h1>
			</div>
		</div>
	);
};
